import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { WhatIShopFor } from './components/WhatIShopFor';
import { Markets } from './components/Markets';
import { OrderForm } from './components/OrderForm';
import { WhyTrustMe } from './components/WhyTrustMe';
import { Testimonials } from './components/Testimonials';
import { DeliveryAreas } from './components/DeliveryAreas';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFab } from './components/WhatsAppFab';
export function App() {
  return <div className="min-h-screen w-full bg-white" data-id="element-0" data-mp="31ctfztgrw49p">
      <TopBar data-id="element-1" data-mp="2wjqff1dkvuk0" />
      <main data-id="element-2" data-mp="2wj8ehrfz0s5r">
        <Hero data-id="element-3" data-mp="2wifc12o1ootf" />
        <HowItWorks data-id="element-4" data-mp="2whxabqim5ie4" />
        <WhatIShopFor data-id="element-5" data-mp="28ufm24yk52fw" />
        <Markets data-id="element-6" data-mp="28tmdcyg1g2v4" />
        <OrderForm data-id="element-7" data-mp="28t4kmbsl46ry" />
        <WhyTrustMe data-id="element-8" data-mp="28sl5f2ubjwhm" />
        <Testimonials data-id="element-9" data-mp="28s31dk1f0dz5" />
        <DeliveryAreas data-id="element-10" data-mp="23vupqgmff2wq" />
        <FinalCTA data-id="element-11" data-mp="23ujksdh8vp41" />
      </main>
      <Footer data-id="element-12" data-mp="23t8iki3g6pf1" />
      <WhatsAppFab data-id="element-13" data-mp="3ijxpcqos80jw" />
    </div>;
}